import React, { useContext } from 'react'
import { Modal } from 'react-bootstrap'
import {
  EmailShareButton,
  FacebookShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from 'react-share'
import {
  EmailIcon,
  FacebookIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
  WorkplaceIcon,
} from 'react-share'
import { Context } from '../../context/context'
const Share = () => {
  const AppContext = useContext(Context)
  return (
    <>
      <MyVerticallyCenteredModal
        show={AppContext.share}
        onHide={() => AppContext.setShare(false)}
      >
        <div className='share-button'>
          <EmailShareButton url={AppContext.url}>
            <EmailIcon iconFillColor='white' size={35}></EmailIcon>
          </EmailShareButton>
          <FacebookShareButton url={AppContext.url}>
            <FacebookIcon iconFillColor='white' size={35}></FacebookIcon>
          </FacebookShareButton>
          <HatenaShareButton url={AppContext.url}>
            <HatenaIcon iconFillColor='white' size={35}></HatenaIcon>
          </HatenaShareButton>
          <InstapaperShareButton url={AppContext.url}>
            <InstapaperIcon iconFillColor='white' size={35}></InstapaperIcon>
          </InstapaperShareButton>
          <LineShareButton url={AppContext.url}>
            <LineIcon iconFillColor='white' size={35}></LineIcon>
          </LineShareButton>
          <LinkedinShareButton url={AppContext.url}>
            <LinkedinIcon iconFillColor='white' size={35}></LinkedinIcon>
          </LinkedinShareButton>
          <LivejournalShareButton url={AppContext.url}>
            <LivejournalIcon iconFillColor='white' size={35}></LivejournalIcon>
          </LivejournalShareButton>
          <MailruShareButton url={AppContext.url}>
            <MailruIcon iconFillColor='white' size={35}></MailruIcon>
          </MailruShareButton>
          <OKShareButton url={AppContext.url}>
            <OKIcon iconFillColor='white' size={35}></OKIcon>
          </OKShareButton>
          <PinterestShareButton url={AppContext.url}>
            <PinterestIcon iconFillColor='white' size={35}></PinterestIcon>
          </PinterestShareButton>
          <TelegramShareButton url={AppContext.url}>
            <TelegramIcon iconFillColor='white' size={35}></TelegramIcon>
          </TelegramShareButton>
          <TwitterShareButton url={AppContext.url}>
            <TwitterIcon iconFillColor='white' size={35}></TwitterIcon>
          </TwitterShareButton>
          <WhatsappShareButton url={AppContext.url}>
            <WhatsappIcon iconFillColor='white' size={35}></WhatsappIcon>
          </WhatsappShareButton>

          <WorkplaceShareButton url={AppContext.url}>
            <WorkplaceIcon iconFillColor='white' size={35}></WorkplaceIcon>
          </WorkplaceShareButton>
        </div>
      </MyVerticallyCenteredModal>
    </>
  )
}

export default Share

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <span>
          شما میتوانید لینک مورد نظر را در تمامی شبکه های زیر به اشتراک بگذارید
        </span>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  )
}
